module.exports = __webpack_public_path__ + "static/media/compare_75.e3d93d02.svg";